// Recherche d'emplacement (décision 17) : majuscules, espaces et tirets ignorés,
// « a12 » trouve « A-12 » et « A 12 ».

export const MAX_SUGGESTIONS = 8

export function normalizeLocation(value)
{
	return (value || '').toString().toLowerCase().replace(/[\s\-_./]/g, '')
}

function compareLocations(a, b)
{
	return (a.location || '').localeCompare(b.location || '', 'fr', { numeric: true, sensitivity: 'base' })
}

// Commence par la saisie d'abord, puis contient la saisie ; ordre naturel (B2 avant B10)
export function searchPitches(pitches, query)
{
	const needle = normalizeLocation(query)
	if (!needle)
		return []
	const starts = []
	const contains = []
	for (let i = 0; i < (pitches || []).length; i++)
	{
		const pitch = pitches[i]
		const hay = normalizeLocation(pitch.location)
		if (hay.startsWith(needle))
			starts.push(pitch)
		else if (hay.includes(needle))
			contains.push(pitch)
	}
	starts.sort(compareLocations)
	contains.sort(compareLocations)
	return starts.concat(contains)
}

export function findPitchByLocation(pitches, location)
{
	const needle = normalizeLocation(location)
	if (!needle)
		return null
	return (pitches || []).find(pitch => normalizeLocation(pitch.location) === needle) || null
}

// Famille d'emplacement, d'après le champ `type` venu du PMS
// (« Location », « Résident », « Saisonnier », « Camping », « Parcelle vide »…).
// L'encodage est parfois abîmé en base (« R?sident ») : on teste sans l'accent.
export function pitchKind(pitch)
{
	const type = ((pitch && pitch.type) || '').toLowerCase()
	if (type === 'location')
		return 'rental'
	if (/^r.?sident/.test(type))
		return 'owner'
	if (type === 'saisonnier')
		return 'seasonal'
	return 'pitch'
}

export function pitchSubtitle(pitch)
{
	const kind = pitchKind(pitch)
	if (kind === 'owner')
		return 'Propriétaire'
	if (kind === 'seasonal')
		return 'Saisonnier'
	const category = ((pitch && pitch.location_category) || '').trim()
	const zone = ((pitch && pitch.zone) || '').trim()
	// Une ligne par information (charte : pas de « · » dans une liste).
	// Une zone d'une lettre (« J ») répète l'allée du numéro : on ne l'affiche pas
	if (zone.length > 1 && !category.toLowerCase().includes(zone.toLowerCase()))
		return category ? category + '\n' + zone : zone
	return category
}

// Un numéro de séjour ne contient que des chiffres
export function cleanStayNumber(value)
{
	return (value || '').toString().replace(/\D/g, '')
}
